<template>
<a v-if="!checked" @click.prevent="toggleTricker" href=""><span class="fas fa-sign-in-alt"></span> REGISTER/LOGIN</a>
<a v-else :href="accountUrl"><span class="fas fa-user"></span> MY ACCOUNT</a>
</template>

<script>
export default{
    props: {
        checked: {
            type: Boolean,
            default: false
        },
        accountUrl: {
            type: String,
            default: '/account'
        }
    },
    methods: {
        toggleTricker(){
            this.$root.user.opened = !this.$root.user.opened;
        }
    }
}

</script>



// WEBPACK FOOTER //
// resources/js/components/Soundrink/soundrink-auth-trigger.vue